import {
  Label,
  Spinner,
  Table,
  TableBody,
  TableCell,
  TableCellLayout,
  TableHeader,
  TableHeaderCell,
  TableRow,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import { Tag, TagGroup } from "@fluentui/react-tags";
import axios from "axios";
import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect, useRef, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "./components/Layout";
import { Base_Url, auth, db } from "./services/firebase";
import CustomSearchInput from "./components/CustomSearchInput";
import debounce from "lodash/debounce";
import {
  CheckBoxChecked,
  CheckBoxUnChecked,
  DownArowSVG,
  DownSmallArrow,
  FilterSVG,
  NodataInfoSVG,
  RadioSelected,
  RadioUnSelected,
} from "./static/svgs";
import userDataService from "./services/userDataService";
import CustomSearchInput2 from "./components/CustomSearchInput2";
import useBreakpoint from "./hooks/useBreakpoint";
import "./components/Forms/FormStyle.css";
import { BookingCategory } from "./Helper";
import {
  getChargeCardAmount,
  getMinimumspend,
  getPointspend,
  parseIntoDollar,
} from "./components/OrderHistoryUtil";
import {
  generateExelData,
  generateTransactionsData,
} from "./components/ReportUtil";
import { useDispatch, useSelector } from "react-redux";
import {
  getMemberList,
  getStripeProductsList,
  setMemberList,
  setStripeProductsList,
} from "./slices/memberSlice";
import StripeProductService from "./services/stripeProductService";

// Update columns to match the charges API response
const columns = [
  { columnKey: "id", label: "ID" }, // Stripe / Clover
  { columnKey: "name", label: "Name" },
  { columnKey: "active", label: "Action" }, // FOR this action and displaying we need to show toggle if is active than toggle is green and if user toggle of than it is greyish type color, right now just take it's toggle click we will implement it further.
];

function StripeProductsListPage() {
  const styles = useStyles();
  const [user, loading, error] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUser, setFilteredUser] = useState([]);
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "mobile";
  const stripeProductsList = useSelector(getStripeProductsList);
  const dispatch = useDispatch();
  const [firebaseProducts, setFirebaseProducts] = useState([]);

  useEffect(() => {
    StripeProductService.getAll().then((snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setFirebaseProducts(list);
    });
  }, []);

  const debouncedSearch = debounce((search) => {
    const lowerSearch = search.toLowerCase();
    const filtered = stripeProductsList.filter((event) => {
      return (
        event.name.toLowerCase().includes(lowerSearch) ||
        String(event.id).toLowerCase().includes(lowerSearch)
      );
    });
    setFilteredUser(filtered);
  }, 300);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };
  const handleClear = () => {
    setSearchTerm("");
    debouncedSearch("");
  };

  const getToggleState = (product) => {
    const firebaseEntry = firebaseProducts.find(
      (p) => p.productId === product.id
    );

    return firebaseEntry ? firebaseEntry.isActive : product.active;
  };

  const handleToggle = async (product) => {
    const firebaseEntry = firebaseProducts.find(
      (p) => p.productId === product.id
    );

    const newValue = !getToggleState(product);
    const now = new Date();

    if (firebaseEntry) {
      // UPDATE existing
      console.log("sdkfjdsfdsfjh:::UPDATE ENTRY");
      await StripeProductService.update(firebaseEntry.id, {
        isActive: newValue,
        updatedAt: now,
        updatedBy: user.email,
      });

      setFirebaseProducts((prev) =>
        prev.map((p) =>
          p.id === firebaseEntry.id
            ? { ...p, isActive: newValue, updatedAt: now }
            : p
        )
      );
    } else {
      console.log("sdkfjdsfdsfjh:::NEW CREATE");
      // CREATE new
      const docRef = await StripeProductService.add({
        productId: product.id,
        isActive: newValue,
        createdAt: now,
        updatedAt: now,
        updatedBy: user.email,
      });

      setFirebaseProducts((prev) => [
        ...prev,
        {
          id: docRef.id,
          productId: product.id,
          isActive: newValue,
          createdAt: now,
          updatedAt: now,
          updatedBy: user.email,
        },
      ]);
    }
  };

  useEffect(() => {
    if (stripeProductsList.length === 0) {
      fetchProductsList(
        (data) => {
          console.log("Fetching Products Success", data);
          const productsWithSelection = (data ?? []).map((product) => ({
            ...product,
            selected: true,
          }));
          dispatch(setStripeProductsList(productsWithSelection));
        },
        (error) => {
          console.log("Fetching Products Error", error);
        }
      );
    }
  }, []);

  const fetchProductsList = (onSuccess, onError) => {
    const config = {
      method: "get",
      url: `${Base_Url}/stripeApi/getAllStripeProducts`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
    };
    axios
      .request(config)
      .then((response) => {
        const responseData = response.data;
        if ((responseData.data ?? []).length > 0) {
          onSuccess(responseData.data);
        } else {
          console.error("No data returned");
        }
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        if (onError) onError(err);
      });
  };

  const displayedProducts =
  searchTerm.trim().length > 0
    ? filteredUser
    : stripeProductsList;

  return (
    <Layout>
      <div className={styles.content}>
        <div className={styles.breakFlex}>
          {/* <Button shape="circular" appearance="primary" onClick={() => navigate(-1)}>Back</Button> */}
        </div>

        <div>
          <CustomSearchInput
            className={"custom-search-input"}
            value={searchTerm}
            onChange={handleSearch}
            onClick={handleClear}
          />
        </div>

        <div
          className="table-layout3"
          style={{ border: isMobile ? "none" : "" }}
        >
          <Table aria-label="Table with cell actions">
            {" "}
            {/* Set min-width here */}
            {isMobile ? null : (
              <TableHeader className="list-row2">
                <TableRow>
                  {columns.map((column) => (
                    <TableHeaderCell
                      key={column.columnKey}
                      style={{ width: column.width }}
                    >
                      <span className="listHeaderText">{column.label}</span>
                    </TableHeaderCell>
                  ))}
                </TableRow>
              </TableHeader>
            )}
            {!isMobile && displayedProducts.length > 0 && (
              <TableBody>
                {displayedProducts.map((product, index) => (
                  <TableRow key={product.id || index}>
                    {/* ID */}
                    <TableCell>
                      <TableCellLayout>{product.id}</TableCellLayout>
                    </TableCell>

                    {/* Name */}
                    <TableCell>
                      <TableCellLayout>
                        <Label>{product.name}</Label>
                      </TableCellLayout>
                    </TableCell>

                    {/* Action */}
                    <TableCell>
                      <TableCellLayout>
                        <div
                          onClick={() => handleToggle(product)}
                          style={{
                            width: "42px",
                            height: "22px",
                            borderRadius: "12px",
                            backgroundColor: getToggleState(product)
                              ? "#22C55E"
                              : "#D1D5DB",
                            position: "relative",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            style={{
                              width: "18px",
                              height: "18px",
                              borderRadius: "50%",
                              backgroundColor: "#FFFFFF",
                              position: "absolute",
                              top: "2px",
                              left: getToggleState(product) ? "22px" : "2px",
                              transition: "left 0.2s ease",
                            }}
                          />
                        </div>
                      </TableCellLayout>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
            {isMobile && displayedProducts.length > 0 && (
              <tbody>
                {displayedProducts.map((product, index) => (
                  <tr key={product.id || index}>
                    <td colSpan={3}>
                      <div className="charges-mobile-card">
                        <div className="charges-mobile-field">
                          <span className="charges-mobile-label">ID:</span>
                          <span className="charges-mobile-value">
                            {product.id}
                          </span>
                        </div>

                        <div className="charges-mobile-field">
                          <span className="charges-mobile-label">Name:</span>
                          <span className="charges-mobile-value">
                            {product.name}
                          </span>
                        </div>

                        <div className="charges-mobile-field">
                          <span className="charges-mobile-label">Action:</span>
                          <span className="charges-mobile-value">
                            <div
                              onClick={() => handleToggle(product)}
                              style={{
                                width: "42px",
                                height: "22px",
                                borderRadius: "12px",
                                backgroundColor: getToggleState(product)
                                  ? "#22C55E"
                                  : "#D1D5DB",
                                position: "relative",
                                cursor: "pointer",
                              }}
                            >
                              <div
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  borderRadius: "50%",
                                  backgroundColor: "#FFFFFF",
                                  position: "absolute",
                                  top: "2px",
                                  left: getToggleState(product)
                                    ? "22px"
                                    : "2px",
                                  transition: "left 0.2s ease",
                                }}
                              />
                            </div>
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
            {
              isLoading ? (
                <div />
              ) : (
                // <TableBody>
                <div className="nodatamain">
                  <div>
                    <NodataInfoSVG />
                  </div>
                  <div className="emptyTitleFont">Products Table is Empty</div>
                  {/*<div className="emprtyDescFont">*/}
                  {/*    Please select customer to view report.*/}
                  {/*</div>*/}
                </div>
              )
              // </TableBody>
            }
          </Table>
        </div>
        <div style={{ marginTop: "10px", textAlign: "center" }}>
          {isLoading && <Spinner />}{" "}
          {/* Render loader if loading state is true */}
        </div>
      </div>
    </Layout>
  );
}

export default StripeProductsListPage;

const useStyles = makeStyles({
  root: {
    ...shorthands.overflow("hidden"),
    display: "flex",
    height: "480px",
    backgroundColor: "#fff",
  },

  content: {
    ...shorthands.flex(1),
    ...shorthands.padding("16px"),
    display: "block",
    ...shorthands.gridArea("main"),
  },

  breakFlex: {
    flexBasis: "100%",
    textAlign: "left",
  },
  popupmain: {
    width: "256px",
    height: "280px",
    position: "relative",
    top: "124px",
    borderRadius: "10px",
    border: "1px solid #F4F4F4",
    background: "#FFF",
    boxShadow: "1px 1px 4px 0px rgba(89, 89, 89, 0.25)",
    padding: "16px",
    overflowY: "auto",
  },
  popupMemberList: {
    paddingTop: "10px",
    maxHeight: "266px",
    overflowY: "auto",
  },
  totalAmount: {
    marginTop: "16px",
    fontWeight: "bold",
  },
});

const styles = {
  productDetailsContainer: {
    display: "flex",
    alignItems: "center",
  },
  imageContainer: {
    marginRight: 10,
  },
  productImage: {
    width: 62,
    height: 62,
    borderRadius: 5,
  },
  productName: {
    color: "#202020",
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  productName2: {
    marginLeft: "6px",
    color: "#202020",
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  productTotal: {
    marginTop: "2px",
    color: "#202020",
    fontFamily: "Nunito Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
  },
  productPrice: {
    fontSize: 12,
    color: "#535353",
  },
  separator: {
    width: "100%",
    borderTop: "1px solid #ccc",
    marginTop: 10,
    marginBottom: 10,
  },
};
